<template>
    <div class="row">
        <div class="col-12">
            <transition mode="out-in" name="component-fade">
                <component
                        :DomainPack="DomainPack"
                        :codePromo="voucher"
                        :emailError="emailError"
                        :form="formTab"
                        :packCountryDomain="packCountryDomain"
                        :role="role"
                        :showCountry="showCountry"
                        :showDomain="showDomain"
                        :tabName="tabName"
                        @disabledButton="getDisabledButton"
                        @formValidate="getformValidate"
                        @getPackCountryDomain="getPackCountryDomainBackOffice"
                        @goToFunctionality="goToFunctionalityLocal"
                        @nextTab="getTabSelected"
                        @noClient="getNoClient"
                        @phoneClick="getPhoneClick"
                        class="tab"
                        v-bind:is="tabSelected"
                ></component>
            </transition>
        </div>
    </div>
</template>

<script>
    import Infos from '../settings/domains/Infos';
    import ClientInfo from '../shared/formInfo/ClientInfo';
    import OrganisationInfo from '../shared/formInfo/OrganisationInfo';
    import InfosModule from '../settings/modules/InfosModule';
    import InfosTypePack from '../settings/typePacks/InfosTypePack';
    import CountryTypePack from '../settings/countries/CountryTypePack';
    import PackDomain from '../settings/packs/PackDomain';
    import InfosFunctionality from '../settings/functionalities/InfosFunctionality';
    import CommercialForm from '../shared/formInfo/InfosCommercial.vue';
    import ClientsTable from '../network/clients/Table';
    import PackInfo from '../shared/formInfo/PackInfo';
    import FunctionalityInfo from '../shared/formInfo/FunctionalityInfo';
    import AdminInfo from '../shared/formInfo/AdminInfo';
    import SettingsInfo from '../shared/formInfo/SettingsInfo';
    import OrganisationsTable from '../organisations/Table';

    export default {
        name: 'TabDetail',
        components: {
            Infos,
            CountryTypePack,
            PackDomain,
            InfosModule,
            InfosTypePack,
            InfosFunctionality,
            CommercialForm,
            ClientsTable,
            ClientInfo,
            OrganisationInfo,
            PackInfo,
            FunctionalityInfo,
            AdminInfo,
            SettingsInfo,
            OrganisationsTable
        },
        props: {
            role: String,
            tabSelected: String,
            component: Object,
            formTab: Object,
            showDomain: Boolean,
            showCountry: Boolean,
            DomainPack: Object,
            emailError: String,
            tabName: String
        },
        data() {
            return {
                isTabSelected: this.tabSelected,
                packCountryDomain: [],
                voucher: this.codePromo
            };
        },
        methods: {
            getTabSelected(selected, codePromo) {
                this.voucher = codePromo;
                this.$emit('nextTab', selected);
            },
            getformValidate(v) {
                this.$emit('formValidate', v);
            },
            getPhoneClick(phoneValidate) {
                this.$emit('phoneClick', phoneValidate);
            },
            getPackCountryDomainBackOffice(packCountryDomain, disabled) {
                this.packCountryDomain = packCountryDomain;
                this.$emit('disabledButton', disabled);
            },
            getDisabledButton(disabled) {
                this.$emit('disabledButton', disabled);
            },
            getNoClient(noClient) {
                this.$emit('noClient', noClient);
            },
            goToFunctionalityLocal(val) {
                this.$emit('goToFunctionality', val);
            }
        }
    };
</script>

<style scoped>

</style>
